import React, { Fragment, useEffect, useState } from "react";
import { NavLink, Link, useNavigate } from "react-router-dom";
import "./headerFooter.scss";
import blackLogo from "../Assets/Images/logoBlack.svg";
import BookDemo from "../Component/Login/BookDemo";
import OutsideClickHandler from "react-outside-click-handler";

export default function Header(props) {
  const [show, setShow] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState("");

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleoutSideClick = (text) => {
    setIsDropdownOpen(text);
  };

  const handleFeatures = (name) => {
    
    localStorage.setItem('name', name);
    const tabname = document.getElementById(name);
      if (tabname) {
        tabname.style.display = 'block';  // Ensure the current section is visible
        tabname.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
      handleoutSideClick()
  };
  return (
    <Fragment>
      <nav className="fixed-top navbar navbar-expand-lg navbar-light">
        <div className="container-fluid">
          <NavLink to="/" className="navbar-brand px-5">
            <img
              src={blackLogo}
              alt="Logo"
              className="d-inline-block logo align-text-top"
            />
          </NavLink>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarTogglerDemo"
            aria-controls="navbarTogglerDemo"
            aria-expanded="false"
            aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarTogglerDemo">
            <ul className="navbar-nav align-items-center gap-3">
              <li className="nav-item header-dropdown mobview1">
                <a
                  className="nav-link"
                  onClick={() => handleoutSideClick("Features")}>
                  Features
                  <i className="fa fa-chevron-down"></i>
                </a>

                {isDropdownOpen === "Features" ? (
                  <OutsideClickHandler
                    onOutsideClick={() => handleoutSideClick("")}>
                    {/* <div className="dropdown-header-menu">
                      <ul className="list-unstyled">
                        <li>
                          <NavLink className="nav-link" to="#">
                            Loyalty
                          </NavLink>
                        </li>
                        <li>
                          <NavLink className="nav-link" to="#">
                            Communication
                          </NavLink>
                        </li>
                        <li>
                          <NavLink className="nav-link" to="#">
                            Referral
                          </NavLink>
                        </li>
                        <li>
                          <NavLink className="nav-link" to="#">
                            Dashboard
                          </NavLink>
                        </li>
                      
                        <li>
                          <NavLink className="nav-link" to="#">
                            Feedback
                          </NavLink>
                        </li>
                        <li>
                          <NavLink className="nav-link" to="#">
                            Digital Receipt
                          </NavLink>
                        </li>
                      </ul>
                    </div> */}
                    <div className="feature-options">
                      <div className="loyalty">
                        <ul className="list-unstyled ">
                          <li>
                            <NavLink className="nav-link" to="#"  onClick={() => handleFeatures("Loyalty")} >
                              <h4>Loyalty</h4>  Build a loyal customer base with DIY programs and rewards.
                            </NavLink>
                          </li>
                          <li>
                            <NavLink className="nav-link" to="#" onClick={() => handleFeatures("Campaign")} >
                              <h4>Campaign</h4>  Engage customers effectively with automated marketing.
                            </NavLink>
                          </li>
                          <li>
                            <NavLink className="nav-link" to="#" onClick={() => handleFeatures("Referral")}>
                              <h4>Referral</h4> Leverage your loyal customers to drive new business through referrals.
                            </NavLink>
                          </li>
                        </ul>
                        <ul className="list-unstyled">
                          <li>
                            <NavLink className="nav-link" to="#" onClick={() => handleFeatures("Dashboard")}>
                              <h4>Dashboard</h4> Track your performance at a glance with comprehensive analytics.
                            </NavLink>
                          </li>

                          <li>
                            <NavLink className="nav-link" to="#" onClick={() => handleFeatures("Feedback")}>
                              <h4>Feedback</h4> Capture and analyze customer feedback to refine your offerings.
                            </NavLink>
                          </li>
                          <li>
                            <NavLink className="nav-link" to="#" onClick={() => handleFeatures("DigitalReceipt")}>
                              <h4>  Digital Receipt</h4> Streamline purchases with customizable digital receipts.
                            </NavLink>
                          </li>
                        </ul>
                      </div>

                    </div>
                  </OutsideClickHandler>
                ) : null}
              </li>
              {/* <li className="nav-item header-dropdown">
                <a
                  className="nav-link"
                >
                  Integrations
                </a>
                {isDropdownOpen === "Integrations " ? (
                  <OutsideClickHandler
                    onOutsideClick={() => handleoutSideClick("")}>
                    <div className="dropdown-header-menu">
                      <ul className="list-unstyled">
                        <li>
                          <NavLink className="nav-link" to="#">
                            Integration Ready Platforms
                          </NavLink>
                        </li>
                        <li>
                          <NavLink className="nav-link" to="#">
                            Partner with Us
                          </NavLink>
                        </li>
                      </ul>
                    </div>
                  </OutsideClickHandler>
                ) : null}
              </li> */}
              {/* <li className="nav-item">
                <NavLink className="nav-link" to="#">
                  Pricing
                </NavLink>
              </li> */}
              <li className="nav-item header-dropdown">
                <a
                  className="nav-link"
                  onClick={() => handleoutSideClick("Resources")}>
                   Resources 
                  <i className="fa fa-chevron-down imged"></i>
                </a>
                {isDropdownOpen === "Resources" ? (
                  <OutsideClickHandler
                    onOutsideClick={() => handleoutSideClick("")}>
                    <div className="dropdown-header-menu">
                      <ul className="list-unstyled">
                        <li>
                          <NavLink className="nav-link" to="#">
                            Integrations
                          </NavLink>
                        </li>
                        <li>
                          <NavLink className="nav-link" to="#">
                            Pricing
                          </NavLink>
                        </li>
                        <li>
                          <NavLink className="nav-link" to="#">
                            News & Events
                          </NavLink>
                        </li>
                        {/* <li>
                          <NavLink className="nav-link" to="#">
                            About Us
                          </NavLink>
                        </li> */}
                      </ul>
                    </div>
                  </OutsideClickHandler>
                ) : null}
              </li>
              <li className="nav-item">
                <NavLink className="nav-link" to="/about-us">
                  About Us
                </NavLink>
              </li>
            </ul>
            <ul className="navbar-nav ms-auto">
              <li className="nav-item right-menu">
                <a className="nav-link d-flex gap-4 align-middle">
                  <button className="btn btn-head-login" type="submit">
                    Login
                  </button>
                  <button
                    className="btn btn-book-demo"
                    type="submit"
                    onClick={() => handleShow()}>
                    Book Demo
                  </button>
                  <button
                    className="btn btn-book-demo-outline"
                    type="submit"
                    onClick={() => handleShow()}>
                    Partner with Us
                  </button>
                  {/* <span className="navbar-toggler-icon"></span> */}
                </a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
      <BookDemo showModal={show} handleCloseModal={handleClose} />
    </Fragment>
  );
}
